<template>
    <div class="quick-view-swiper">
        <Swiper v-bind="swiperOptions">
            <template v-for="(image, key) in images" :key="key">
                <SwiperSlide v-if="image && typeof image ==='string' && key !== 'json_video' && key !== 'json_video_two'">
                     <div class="d-flex justify-content-center align-items-center">
                        <img width="250" height="250" :src="image" :alt="key">
                        <!-- <span class="fiery" v-if="data?.is_fiery_round === 1 && moduleType === 'loose' && key==='diamond_image'">Fiery Round</span> -->
                     </div>
                </SwiperSlide>
            </template>
            <swiper-slide v-if="images && images?.json_video">
                <div class="iframe-container">
                    <iframe :src="images?.json_video" style="width: 100%; height:250px;"></iframe>
                    <div v-if="data?.is_supplier_stone === 1" class="inter_lab">Click to play</div>
                </div>
            </swiper-slide>

            <swiper-slide v-if="images && images?.json_video_two">
                <div class="iframe-container">
                    <iframe :src="images?.json_video_two" style="width: 100%; height:250px;"></iframe>
                    <div v-if="data?.is_supplier_stone === 1" class="inter_lab">Click to play</div>
                </div>
            </swiper-slide>
            <div class="quick-view-pg swiper-pagination"></div>
        </Swiper>
    </div>
</template>
<script setup>
import { Pagination } from 'swiper/modules';

const { images, data } = defineProps(['images','data',])


const route = useRoute()
const moduleType = route.meta.moduleType


const swiperOptions = {
      spaceBetween: 20,
      modules: [Pagination],
      pagination: {
        clickable: true,
        disableOnInteraction: false,
        el:'.quick-view-pg'
    },
  };

</script>

<style scoped>

.inter_lab {
    position: absolute;
    top: 5px;
    left: 5px;
    background: #b7b7b7;
    color: #fff;
    font-size: 13px;
    letter-spacing: 0.5px;
    font-weight: 600;
    border-radius: 4px;
    padding: 1px 6px;
}

img,
video,
iframe {
    border-radius: 8px;
}

video,img {
    max-width: 100%;
    height: auto;
}

.quick-view-swiper {
    width: 100%;
}


:global(.quick-view-swiper .swiper-slide) {
    height: auto !important;
}

/* swiper pagination: mobile */
:global(.quick-view-swiper .swiper-pagination) {
    position: relative;
    margin-top: 1rem;
    z-index: 1;
}

:global(.quick-view-swiper .swiper-pagination-bullet) {
    background: transparent !important;
    opacity: 1 !important;
    margin: 0 5px !important;
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 0 !important;
}

:global(.quick-view-swiper .swiper-pagination-bullet::before) {
    content: '';
    position: absolute;
    top: 50%;   
    left: 50%;
    transform: translate(-50%, -50%);
    z-index:   -1;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: #c4c4c4 !important;
    opacity: 1 !important;
}

:global(.quick-view-swiper .swiper-pagination-bullet-active::before) {
    background: #606060 !important;
}


.iframe-container{
    position: relative;
    width: 250px;
    height: 250px;
    margin:auto;
}
iframe {
    position: absolute; 
    top: 0; 
    left: 0; 
    width: 100%; 
    height: 100%;
    max-width: 100%;
}

.fiery {
    color: #353535 !important;
    font-size: 14px;
    font-weight: 500;
    text-transform: capitalize !important;
    /* margin: 2px; */
    background: #668b844c;
    padding: 2px 8px;
    border-radius: 4px;
    position: absolute;
    left: 8px;
    top: 8px;
}

</style>